import React from "react";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import InlineDatePicker from "../../utils/InlineDatePicker"
import Card from "components/Card/Card.jsx";
import Amount from "@material-ui/icons/AccountBalanceWalletTwoTone";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import { appHelpers } from "../../_helpers";


import {
    Grid,
} from "@material-ui/core";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200
    },
    root: {
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        // margin: theme.spacing.unit,
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px"
    }
});

function SettingsPanel(props) {
    const {
        classes,
        handleSearch,
        handleDateChange,
        startDate,
        endDate,
        endLabel,
        startLabel,
        todayExchangeRate

    } = props;

    return (
        <div className={classes.root}>
            <form className={classes.container} noValidate >
                <Grid container spacing={24} style={{ margin: "15px", padding: "10px" }}>
                    <Grid item md={3} xs={12}>
                        <Card>
                            <CardHeader color="danger" stats icon>
                                <CardIcon color="danger">
                                    <Amount />
                                </CardIcon>
                                <div style={{ color: "#212121" }}>
                                    <p className={classes.cardCategory}>Today's Exchange Rate</p>
                                    <h3 className={classes.cardTitle}>
                                        &#8358;{" "}
                                        {typeof todayExchangeRate === "number"
                                            ? appHelpers.numberWithCommas(todayExchangeRate)
                                            : todayExchangeRate}
                                    </h3>
                                </div>
                            </CardHeader>
                        </Card>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <div className="picker" style={{ marginTop: "5.5vw" }}>
                            <InlineDatePicker Date={startDate} handleDateChange={(date) => handleDateChange(date, 'startDate')} label={startLabel} />
                        </div>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <div className="picker" style={{ marginTop: "5.5vw", marginLeft:"2.2vw" }}>
                            <InlineDatePicker Date={endDate} handleDateChange={(date) => handleDateChange(date, 'endDate')} label={endLabel} />
                        </div>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <Button
                            color={"regional"}
                            onClick={() => handleSearch()}
                            style={{ marginTop: "6vw", marginLeft:"3.8vw" }}
                        >
                            Search
                  </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
};


export default withStyles(styles)(SettingsPanel);



// WEBPACK FOOTER //
// ./src/Regional-Views/ExchangeRateAirline/settingsPanel.js